import { combineReducers } from 'redux';
import { keyBy, map, merge } from 'lodash/fp';
import { dissoc, assoc } from 'ramda';
import {
  FETCH_GIFT_CARDS,
  FETCH_GIFT_CARDS_SUCCESS,
  FETCH_GIFT_CARD_SUMMARY,
  RESET_SOLD_GIFT_CARDS,
  SET_SOLD_GIFT_CARDS,
  DELETE_GIFT_CARD,
  ADD_GIFT_CARD,
} from './constants';
import valueReducer from '../../common/reducers/valueReducer';
import { dropItem, addItem } from '../../common/helpers/functional';

const byId = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_GIFT_CARDS:
      return {};
    case FETCH_GIFT_CARDS_SUCCESS:
      return merge(keyBy('id', payload), state);
    case DELETE_GIFT_CARD:
      return dissoc(payload, state);
    case ADD_GIFT_CARD:
      return assoc(payload.id, payload, state);
    default:
      return state;
  }
};

const list = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_GIFT_CARDS:
      return [];
    case FETCH_GIFT_CARDS_SUCCESS:
      return [...state, ...map('id', payload)];
    case DELETE_GIFT_CARD:
      return dropItem(payload, state);
    case ADD_GIFT_CARD:
      return addItem(payload.id, state);
    default:
      return state;
  }
};

const items = combineReducers({
  byId,
  list,
});

const isLoading = (state = false, { type }) => {
  switch (type) {
    case FETCH_GIFT_CARDS:
      return true;
    case FETCH_GIFT_CARDS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const summary = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_GIFT_CARD_SUMMARY:
      return payload;

    default:
      return state;
  }
};

const soldGiftCards = valueReducer([], SET_SOLD_GIFT_CARDS, RESET_SOLD_GIFT_CARDS);

export default combineReducers({
  items,
  isLoading,
  summary,
  soldGiftCards,
});
